"use client"; // Error boundaries must be Client Components

import { AppError } from "@/lib/utils/errors";
import Image from "next/image";
import wrongImage from "@/assets/imgs/something-wrong.png";
import { useEffect } from "react";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // TODO: Log the error to an error reporting service
    const appErr = new AppError(error);
    appErr.logError();
  }, [error]);

  return (
    <div className="w-full">
      <div className="w-full h-[60vh] flex justify-center items-center flex-col gap-5">
        <Image
          className="w-80 h-80"
          src={wrongImage}
          alt="Something went wrong | Together Work"
          width={500}
          height={500}
        />
        <h2 className="text-lg font-bold hidden">Something went wrong!</h2>
        <div className="flex justify-center items-center gap-3">
          <button
            className="w-28 h-10 flex justify-center items-center bg-primary text-white rounded-md"
            onClick={
              // Attempt to recover by trying to re-render the segment
              () => window && window.location.reload()
            }
          >
            <span>Please try again</span>
          </button>
          <span className="text-lg text-primary font-bold">Or</span>
          <button
            className="w-28 h-10 flex justify-center items-center bg-primary text-white rounded-md"
            onClick={() => window && window.location.replace("/")}
          >
            <span> Go to home</span>
          </button>
        </div>
      </div>
    </div>
  );
}
